module.exports = __webpack_public_path__ + "img/menu.b7c64fa9.svg";